module.exports = __webpack_public_path__ + "static/social-169ddafd771fe9b78173829b33e1529e.png";